import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // The unchecked track gets a visible rim. Under the Googie shell
      // `--input` is near-black and so is `--background`, so an
      // off switch used to be a dark pill holding a dark thumb —
      // nothing to see, in either state. Rennan: "i cant tell when its
      // on or off because it fills the whole button."
      // Rennan: "should only fill when toggled on." OFF is an outline —
      // no fill at all — and ON is solid. Previously both states were
      // filled (`bg-input` vs `bg-primary`), which under the Googie
      // shell meant a dark well against a dark card: two filled pills
      // that differed only in hue.
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 transition-colors data-[state=checked]:border-transparent data-[state=checked]:bg-primary data-[state=unchecked]:border-foreground/30 data-[state=unchecked]:bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        // White, not `bg-background` — the thumb has to read against the
        // track whatever the track is, and on every theme the track is
        // either a saturated colour or a dark well.
        // White on, muted off — so the knob says the same thing as the
        // track rather than being the only thing you can see.
        "pointer-events-none block h-5 w-5 rounded-full shadow-[0_1px_3px_rgba(0,0,0,0.35)] ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=checked]:bg-white data-[state=unchecked]:translate-x-0 data-[state=unchecked]:bg-foreground/45",
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
